export enum SurveyPlatform {
  ZOHO = "ZOHO",
}
